import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import LandingPageContainer from './landing-page-container';
import { prefix } from '../../lib/auth';
import { IconMenuDeep, IconX } from '@tabler/icons-react';

const navLinks = [
    { href: '#features', label: 'Features' },
    { href: '#sdk-overview', label: 'SDK Overview' },
    { href: '#quickstart', label: 'Quickstart' },
];

const LandingPageHeader = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <div className='relative'>
            <div className='flex items-center justify-between py-[12px] !font-geist lg:max-w-[1360px]  lg:px-[30px] m-auto px-[16px] lg:gap-[32px]'>
                <div className='flex items-center gap-[8px]'>
                    <Image src='https://cdn.workpeg.com/pegs/home/assets/logo/secondary-dark.svg' alt='logo' width={141} height={28} className='h-[24px] lg:h-[28px]' />
                    <div className='!font-geist py-[5px] px-[12px] rounded-full border-[#1C1C1C] border-[1px] text-[#ffffff] text-[12px] leading-[16px]'>Developers</div>
                </div>
                <ul className='hidden lg:flex items-center gap-[10px]'>
                    {navLinks.map((link) => (
                        <li key={link.href}>
                            <Link href={link.href} className='font-geist py-[8px] px-[12px] rounded-full text-[#B0B0B0] hover:bg-[#2E2E2E] hover:text-[#ffffff] text-[14px] leading-[16px] !font-medium'>
                                {link.label}
                            </Link>
                        </li>
                    ))}
                </ul>
                <div className='hidden lg:flex items-center w-[235px] justify-end'>
                    {/* <Link href={`http://${prefix()}accounts.workpeg.com/login?peg=developers`} className='!font-geist py-[8px] px-[16px] rounded-full text-[#B0B0B0] hover:text-[#ffffff] text-[14px] leading-[20px]'>Sign in</Link> */}
                    <Link href={`http://${prefix()}accounts.workpeg.com/register?peg=developers`} className='!font-geist py-[8px] px-[16px] rounded-full text-[#000000] hover:bg-[#FAFAFA] bg-[#FFFFFF] !font-geist py-[8px] px-[16px] rounded-full text-[#000000] text-[14px] leading-[20px] text-[14px] leading-[20px]'>
                        Start building
                    </Link>
                </div>
                <button
                    type='button'
                    onClick={() => setIsMenuOpen((prev) => !prev)}
                    aria-label='Toggle navigation menu'
                    aria-expanded={isMenuOpen}
                    className='lg:hidden flex items-center justify-center w-[36px] h-[36px] text-[#B0B0B0] hover:text-[#ffffff] transition-colors duration-200'
                >
                    {isMenuOpen ? <IconX size={22} stroke={1.5} /> : <IconMenuDeep size={22} stroke={1.5} />}
                </button>
            </div>

            <div className={`lg:hidden grid overflow-hidden transition-[grid-template-rows] duration-300 ease-in-out ${isMenuOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                <div className='overflow-hidden min-h-0 border-t border-[#1C1C1C] bg-[#000000]'>
                    <ul className='flex flex-col px-[16px] py-[16px] gap-[4px]'>
                        {navLinks.map((link) => (
                            <li key={link.href}>
                                <Link
                                    href={link.href}
                                    onClick={() => setIsMenuOpen(false)}
                                    className='block font-geist py-[10px] px-[12px] rounded-lg text-[#B0B0B0] hover:bg-[#2E2E2E] hover:text-[#ffffff] text-[14px] !font-medium'
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                    <div className='flex flex-col gap-[8px] px-[16px] pb-[16px]'>
                        {/* <Link
                            href={`http://${prefix()}accounts.workpeg.com/login?peg=developers`}
                            onClick={() => setIsMenuOpen(false)}
                            className='!font-geist py-[10px] px-[16px] rounded-full text-[#B0B0B0] hover:text-[#ffffff] text-[14px] leading-[20px] text-center border border-[#1C1C1C]'
                        >
                            Sign in
                        </Link> */}
                        <Link
                            href={`http://${prefix()}accounts.workpeg.com/register?peg=developers`}
                            onClick={() => setIsMenuOpen(false)}
                            className='!font-geist py-[10px] px-[16px] rounded-full text-[#000000] hover:bg-[#FAFAFA] bg-[#FFFFFF] text-[14px] leading-[20px] text-center'
                        >
                            Start building
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LandingPageHeader;